import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

const base = `${process.env.REACT_APP_API_HOST}/${apiConstants.PORTAL}`;
const data = async (p) => (await p).data;

// Customer portal API. The server scopes everything to the caller's org.
export const getDashboard = () => data(axios.get(`${base}/dashboard`));

export const listRequirements = (params = {}) => data(axios.get(`${base}/requirements`, { params }));
export const getRequirement = (number) => data(axios.get(`${base}/requirements/${number}`));
export const submitRequirement = (form) => axios.post(`${base}/requirements`, form); // FormData
export const addRequirementComment = (number, text) => axios.post(`${base}/requirements/${number}/comments`, { text });

export const listQuotations = () => data(axios.get(`${base}/quotations`));
export const getQuotation = (id) => data(axios.get(`${base}/quotations/${id}`));
export const decideQuotation = (id, decision, note) => axios.post(`${base}/quotations/${id}/decision`, { decision, note });

export const listOrders = () => data(axios.get(`${base}/orders`));
export const getOrder = (id) => data(axios.get(`${base}/orders/${id}`));
export const uploadPo = (id, form) => axios.post(`${base}/orders/${id}/po`, form); // FormData
export const confirmDelivery = (id, remarks) => axios.post(`${base}/orders/${id}/confirm-delivery`, { remarks });

// The approved catalogue, already priced for this society.
export const browseCatalogue = () => data(axios.get(`${base}/catalogue`));

// The working list a society builds before asking for a quotation.
export const getList = () => data(axios.get(`${base}/list`));
export const addToList = (body) => data(axios.post(`${base}/list`, body));
export const setListQuantity = (id, quantity) => data(axios.put(`${base}/list/${id}`, { quantity }));
export const removeFromList = (id) => data(axios.delete(`${base}/list/${id}`));
export const clearList = () => data(axios.delete(`${base}/list`));

// The society's account with us: invoices, quotations, what is still owed.
export const getAccount = () => data(axios.get(`${base}/account`));
